// extracted by mini-css-extract-plugin
export default {"heading-icon":"UsagePurchaseContainer__heading-icon__K5SzF"};